<div class="details-dialog-container" #tableHost>
	<div class="row">
		<div class="col-sm-3">
			<button
				class="btn btn-submit"
				[ngClass]="{
					'btn-success': ucdpData.submissions.canSubmitUCDP,
					'btn-secondary': !ucdpData.submissions.canSubmitUCDP
				}"
				(click)="triggerSubmitAction('ucdp')"
			>
				<i
					*ngIf="!ucdpData.submissions.canSubmitUCDP"
					class="fa-duotone fa-regular fa-triangle-exclamation color-warning me-1"
				></i>
				Submit to UCDP
			</button>
			<button
				class="btn btn-submit ms-2"
				[ngClass]="{
					'btn-success': ucdpData.submissions.canSubmitEAD,
					'btn-secondary': !ucdpData.submissions.canSubmitEAD
				}"
				(click)="triggerSubmitAction('ead')"
			>
				<i
					*ngIf="!ucdpData.submissions.canSubmitEAD"
					class="fa-duotone fa-regular fa-triangle-exclamation color-warning me-1"
				></i>
				Submit to EAD
			</button>
			<hr />
			<div class="d-grid gap-2">
				<button class="btn btn-submit btn-success" (click)="openOverrideData()">
					Set Manual UCDP/EAD data
				</button>
			</div>
		</div>
		<div class="col-sm-9">
			<dl class="row">
				<dt class="col-sm-3 text-end">is UCDP/EAD Submission Required?</dt>
				<dd class="col-sm-9">{{ ucdpData.submissions.requestedAction }}</dd>
				<dt class="col-sm-3 text-end">Loan #:</dt>
				<dd class="col-sm-9">
					{{ orderDetail.externalLoanNumber || ucdpData.submissions.lastDocFileId || 'N/A' }}
				</dd>
				<dt class="col-sm-3 text-end"><strong>UCDP</strong> Doc File ID:</dt>
				<dd class="col-sm-9">{{ ucdpData.submissions.docFileIdUCDP || 'N/A' }}</dd>
				<dt class="col-sm-3 text-end"><strong>EAD</strong> Doc File ID:</dt>
				<dd class="col-sm-9">{{ ucdpData.submissions.docFileIdEAD || 'N/A' }}</dd>
				<dt class="col-sm-3 text-end">CU Score:</dt>
				<dd class="col-sm-9">{{ ucdpData.submissions.lastCUScore || 'N/A' }}</dd>
				<dt class="col-sm-3 text-end">LCA Score:</dt>
				<dd class="col-sm-9">{{ ucdpData.submissions.lastLCAScore || 'N/A' }}</dd>
			</dl>
		</div>
	</div>
	<hr class="mt-1" />
	<div class="row">
		<div class="col-sm-12">
			<div class="info-text">
				<p>
					<i class="fa-regular fa-circle-info text-primary"></i> If this report is being delivered through the
					UCDP or EAD portal, then the submissions that have occurred are recorded here. Each submission may
					pass or fail, with specific reasons cited in the event of a failure.
				</p>
			</div>

			<p-table
				[scrollable]="true"
				scrollHeight="400px"
				[value]="ucdpData.submissions.data ?? []"
				[loading]="loading"
				selectionMode="single"
				[(selection)]="submissionSelected"
				(onRowSelect)="loadSubmissionData()"
			>
				<ng-template pTemplate="header">
					<tr>
						<th>Requested</th>
						<th>Responded</th>
						<th>Status</th>
						<th>Portal</th>
						<th>Passed</th>
						<th>Findings</th>
						<th>Hard Stops</th>
						<th class="text-center">FILES</th>
					</tr>
				</ng-template>

				<ng-template pTemplate="body" let-row>
					<tr [pSelectableRow]="row" class="row-selectable">
						<td>{{ row.requested | date: 'M/d/yyyy h:mm a' }}</td>
						<td>{{ row.responded | date: 'M/d/yyyy h:mm a' }}</td>
						<td>
							<strong>{{ row.transactionStatus }}</strong>
						</td>
						<td class="text-uppercase">{{ row.service }}</td>
						<td>
							<ng-container *ngIf="row.transactionStatus !== 'Inprocess'">
								<span *ngIf="row.passed">Yes</span>
								<button *ngIf="!row.passed"
									class="btn btn-sm btn-outline-warning"
									(click)="openSubmissionError(row)">
									<i class="fas fa-circle-info"></i>
									<span class="ms-1">No</span>
								</button>
							</ng-container>
							<ng-container *ngIf="row.transactionStatus === 'Inprocess'">
								--
							</ng-container>
						</td>
						<td>{{ row.findings }}</td>
						<td>{{ row.hardStops }}</td>
						<td class="text-center actions p-0">
							<div class="row mx-0">
								<div class="col" *ngFor="let provider of row.providers">
									<a class="text-decoration-none" [href]="provider.documentUrl" target="_blank">
										<span class="d-block">
											<i class="fa-regular text-danger fs-3"
												[ngClass]="{
													'fa-file-pdf': provider?.documentFormat === 'PDF',
													'fa-file-code': provider?.documentFormat === 'JSON',
													'fa-file': !provider?.documentFormat || provider?.documentFormat === ''
												}"></i>
										</span>
										<span class="text-uppercase fw-bold mb-0 d-block text-dark">{{
											provider.provider
										}}</span>
									</a>
								</div>
							</div>
						</td>
					</tr>
				</ng-template>

				<ng-template pTemplate="emptymessage">
					<tr>
						<td colspan="9" class="text-center">
							<strong>No QC Submissions found for this order</strong>
						</td>
					</tr>
				</ng-template>
			</p-table>
		</div>
	</div>
	<hr />
	<div class="row">
		<div class="col-sm-12">
			<div class="info-text">
				<p>
					<i class="fa-regular fa-circle-info text-primary"></i> Select a submission above to view its
					detailed findings and hard stops below. Each row represents an individual submission to the UCDP or
					EAD portal.
				</p>
			</div>
			<ng-container *ngIf="submissionSelected.submissionId">
				<cv-tab-group>
					<cv-tab title="HardStops" [active]="true">
						<p-table
							[scrollable]="true"
							scrollHeight="400px"
							[value]="ucdpData.hardstops ?? []"
							[loading]="loadingSub"
						>
							<ng-template pTemplate="header">
								<tr>
									<th>Action</th>
									<th>Hard Stop Code</th>
									<th>Description</th>
									<th>Can Override?</th>
									<th>Override Code</th>
									<th>Override Comment</th>
									<th>Resolved?</th>
								</tr>
							</ng-template>

							<ng-template pTemplate="body" let-row>
								<tr>
									<td>
										<button
											*ngIf="row.canOverride"
											type="button"
											class="btn btn-link text-decoration-none"
											(click)="openOverride(row)"
										>
											Override
										</button>
									</td>
									<td>{{ row.hardstop }}</td>
									<td>{{ row.description }}</td>
									<td>{{ row.canOverride ? 'Yes' : 'No' }}</td>
									<td>{{ row.autoOverride ? 'Auto' : row.overrideReasonCode }}</td>
									<td>{{ row.overrideComment }}</td>
									<td>{{ row.overrideSubmitted ? 'Yes' : row.autoOverride ? 'Yes' : 'No' }}</td>
								</tr>
							</ng-template>

							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="9" class="text-center">
										<strong>No "Hard Stops" found.</strong>
									</td>
								</tr>
							</ng-template>
						</p-table>
					</cv-tab>
					<cv-tab title="Findings">
						<p-table
							[scrollable]="true"
							scrollHeight="400px"
							[value]="ucdpData.findings ?? []"
							[loading]="loadingSub"
						>
							<ng-template pTemplate="header">
								<tr>
									<th>Rule</th>
									<th>Description</th>
									<th>Responded</th>
								</tr>
							</ng-template>

							<ng-template pTemplate="body" let-row>
								<tr>
									<td>{{ row.rule }}</td>
									<td>{{ row.description }}</td>
									<td>{{ row.responseDate | date: 'M/d/yyyy h:mm a' }}</td>
								</tr>
							</ng-template>

							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="9" class="text-center">
										<strong>No "Findings" found.</strong>
									</td>
								</tr>
							</ng-template>
						</p-table>
					</cv-tab>
				</cv-tab-group>

				<hr />
				<div *ngIf="canSubmitOverrides">
					<div class="info-text">
						<p>
							<i class="fa-regular fa-circle-info text-primary"></i> Once you have
							<strong>OVERRIDE</strong> all the Hardstops, please, hit the button below to resubmit the
							changes.
						</p>
					</div>
					<button class="btn btn-success" (click)="submitOverrides()">Submit Changes</button>
				</div>
			</ng-container>
		</div>
	</div>

	<p-dialog
		[draggable]="false"
		[resizable]="false"
		[closable]="false"
		[modal]="true"
		[(visible)]="basicModal.showSubmissionErrors"
		[style]="{ width: '600px' }"
		class="basic-modal"
	>
		<div class="container-fluid">
			<div class="row justify-content-center">
				<div class="col-sm-8 text-center">
					<i class="fas fa-exclamation-triangle fa-5x color-warning mb-2"></i>
					<h4 class="color-info mb-4">Can't submit to {{ basicModal.serviceName.toUpperCase() }}</h4>
				</div>
			</div>
			<div class="row">
				<div class="col">
					<ul>
						<li *ngFor="let item of basicModal.message">{{ item }}</li>
					</ul>
				</div>
			</div>
		</div>

		<ng-template pTemplate="footer">
			<p-button
				(click)="basicModal.showSubmissionErrors = false"
				label="Close"
				styleClass="p-button-text"
			></p-button>
		</ng-template>
	</p-dialog>
</div>
